import { InputText } from "primereact/inputtext";
import { InputNumber } from "primereact/inputnumber";
import { Dropdown } from "primereact/dropdown";
import { ColumnFilterElementTemplateOptions } from "primereact/column";
import DateFilterMenu from "./DateFilterMenu";
import {
  FilterOption,
  useCompanyFilterOptions,
  useProjectFilterOptions,
} from "../../hooks/api/use-filterOptions";

export const filterTextInput = (value: string, filter: string): boolean => {
  if (!filter) return true;
  if (!value) return false;
  return value.toLowerCase().includes(filter.toLowerCase());
};

export const textFilterTemplate = (
  options: ColumnFilterElementTemplateOptions
) => {
  return (
    <InputText
      type="text"
      value={options.value || ""}
      onChange={(e) => options.filterApplyCallback(e.target.value)}
      placeholder="Поиск..."
      className="p-column-filter"
    />
  );
};

export const filterNumberInput = (value: number, filter: number): boolean => {
  if (!filter || filter === null || filter === undefined) return true;
  if (!value || value === null || value === undefined) return false;
  return value === filter;
};

export const filterIncludeNumberInput = (
  value: number,
  filter: number
): boolean => {
  if (!filter || filter === null || filter === undefined) return true;
  if (!value || value === null || value === undefined) return false;
  return value.toString().includes(filter.toString());
};

export const numberFilterMatchModeOptions = [
  { label: "Равно", value: "equals" },
  { label: "Не равно", value: "notEquals" },
  { label: "Больше", value: "gt" },
  { label: "Меньше", value: "lt" },
  { label: "Больше или равно", value: "gte" },
  { label: "Меньше или равно", value: "lte" },
];

export const numberFilterTemplate = (
  options: ColumnFilterElementTemplateOptions
) => {
  return (
    <InputNumber
      value={options.value ?? null}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder="Поиск..."
      className="p-column-filter"
    />
  );
};

export const dateFilterFunction = (
  value: string | Date,
  filter: any
): boolean => {
  if (!filter || !filter.value || filter === undefined) return true;
  const rowDate = new Date(value).setHours(0, 0, 0, 0);
  const filterDate = new Date(filter.value).setHours(0, 0, 0, 0);
  switch (filter.operator) {
    case "equals":
      return rowDate === filterDate;
    case "after":
      return rowDate > filterDate;
    case "before":
      return rowDate < filterDate;
    default:
      return true;
  }
};

export const dateFilterTemplate = (
  options: ColumnFilterElementTemplateOptions
) => {
  return (
    <DateFilterMenu
      value={options.value}
      filterApplyCallback={options.filterApplyCallback}
    />
  );
};

/* --------------------- Фильтры-дропдауны по справочникам -------------------- */

/** Точное совпадение со значением, выбранным в дропдауне */
export const filterEqualsOption = (
  value: string,
  filter: string | null
): boolean => {
  if (!filter) return true;
  if (!value) return false;
  return value === filter;
};

interface DropdownFilterProps {
  options: ColumnFilterElementTemplateOptions;
  values: FilterOption[];
  placeholder: string;
}

const DropdownFilter = ({
  options,
  values,
  placeholder,
}: DropdownFilterProps) => {
  return (
    <Dropdown
      value={options.value ?? null}
      options={values}
      onChange={(e) => options.filterApplyCallback(e.value)}
      placeholder={placeholder}
      className="p-column-filter"
      filter
      showClear
      emptyMessage="Нет данных"
      emptyFilterMessage="Ничего не найдено"
    />
  );
};

/** Дропдаун с названиями проектов, полученными с API */
const ProjectDropdownFilter = ({
  options,
}: {
  options: ColumnFilterElementTemplateOptions;
}) => {
  const values = useProjectFilterOptions();
  return (
    <DropdownFilter
      options={options}
      values={values}
      placeholder="Программное обеспечение"
    />
  );
};

/** Дропдаун с названиями компаний, полученными с API */
const CompanyDropdownFilter = ({
  options,
}: {
  options: ColumnFilterElementTemplateOptions;
}) => {
  const values = useCompanyFilterOptions();
  return (
    <DropdownFilter options={options} values={values} placeholder="Компания" />
  );
};

export const projectFilterTemplate = (
  options: ColumnFilterElementTemplateOptions
) => <ProjectDropdownFilter options={options} />;

export const companyFilterTemplate = (
  options: ColumnFilterElementTemplateOptions
) => <CompanyDropdownFilter options={options} />;
